import { Button } from '@warp-ds/react/components/button';

export const FetchFailedMessage = () => {
    const handleReload = () => {
        window.location.reload();
    };

    return (
        <p className="p-16 text-22 font-bold text-center flex flex-col items-center gap-8" data-testid="fetchFailed">
            Noe gikk galt under henting av tilbud.
            <Button secondary quiet onClick={handleReload} className="p-0! m-0! text-22 hover:underline hover:bg-transparent">
                Prøv å laste siden på nytt.
            </Button>
        </p>
    );
};
